import {
    FETCH_DASHBOARD_SUCCEESS,
    FETCH_DASHBOARD_TOKEN,
    FETCH_DASHBOARD_FAILED,
} from '../actions/actionsTypes';

const initialState = {
    loading: false,
    data: [],
    error: false,
};

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DASHBOARD_TOKEN:
            return {
                ...state,
                loading: true,
            };
        case FETCH_DASHBOARD_SUCCEESS:
            return {
                loading: false,
                data: action.payload,
                error: false,
            };
        case FETCH_DASHBOARD_FAILED:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state
    }
};

export default dashboardReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/dashboardReducer.js